/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {PlatformService as ɵa} from './@core/providers/platform-service/platform.service';
export {BrowserInfo as ɵb} from './@directives/browsers/browser-info';
export {IeInfo as ɵc} from './@directives/browsers/ie-info';
export {DevicesInfo as ɵd} from './@directives/devices/devices-info';
export {DeviceStandardInfo as ɵe} from './@directives/devices/devices-standard-info';
export {OrientationInfo as ɵf} from './@directives/devices/orientation-info';